import { makeStyles, StepConnector, withStyles } from '@material-ui/core';
import styled from 'styled-components';
import { supportGreen } from 'Material-UI/colors';
import { Captions, ShortBody } from 'components/Typography';
export const useStepIconStyles = makeStyles({
  root: {
    color: '#C4C9D3',
  },
  active: {
    width: 17,
    height: 17,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#F4B63E',
  },
  completed: {
    color: supportGreen,
    width: 17,
    height: 17,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export const Connector = withStyles({
  root: {
    padding: 0,
    position: 'relative',
    top: '-33px',
    marginLeft: 8,
  },
  active: {
    '& $line': {
      borderColor: '#F4B63E',
    },
  },
  completed: {
    '& $line': {
      borderColor: supportGreen,
    },
  },
  line: {
    borderColor: '#F4B63E',
    borderWidth: 1,
    borderLeftStyle: 'dashed',
    boxSizing: 'border-box',
    position: 'absolute',
    minHeight: 31,
  },
})(StepConnector);

export const StyledCaptions = styled(Captions)<{
  isAlignEnd?: boolean;
  marginBottom: number;
}>`
  && {
    margin-bottom: ${({ marginBottom }) => `${marginBottom}px`};
    text-align: ${({ isAlignEnd = false }) => (isAlignEnd ? 'end' : 'start')};
  }
`;
export const SizedCaptions = styled(ShortBody)`
  && {
    margin-bottom: 0px;
  }
`;
